<template>
  <CourseVideoPlaceholderOverlay>
    <PlayButton @click="play" v-if="isPlayButtonVisible" />

    <span v-if="isPlayerBuffering">
      <LoadingBox />
    </span>

    <CourseVideoPlaceholderIntroEnd :course-id="course.id" :course-class-id="courseModuleClass.id" v-if="isIntroEndVisible" />
    <CourseVideoPlaceholderGuest v-if="isPlaceholderGuestVisible" />
  </CourseVideoPlaceholderOverlay>
</template>''

<script>
import CourseVideoPlaceholderOverlay from './CourseVideoPlaceholderOverlay'
import CourseVideoPlaceholderIntroEnd from './CourseVideoPlaceholderIntroEnd'
import CourseVideoPlaceholderGuest from './CourseVideoPlaceholderGuest'
import PlayButton from '@/components/buttons/PlayButton'
import { mapGetters, mapActions } from 'vuex'
import LoadingBox from '@/components/layout/LoadingBox'

export default {
  components: {
    CourseVideoPlaceholderOverlay,
    CourseVideoPlaceholderIntroEnd,
    CourseVideoPlaceholderGuest,
    PlayButton,
    LoadingBox,
  },

  props: {
    isVideoEnded: { type: Boolean, default: false }
  },

  data: () => ({
    isPlayed: false,
  }),

  computed: {
    ...mapGetters('user', ['isLogged']),

    ...mapGetters('course', ['courseModuleClass', 'course']),

    ...mapGetters('player', ['isPlayerLoaded', 'isPlayerStopped', 'isPlayerBuffering', 'isPlayerPlaying', 'isPlayerEnded']),

    isPlayButtonVisible () {
      return !this.isPlayed && this.isPlayerLoaded && !this.isPlayerPlaying && !this.isPlayerBuffering && !this.isIntroEndVisible && !this.isPlaceholderGuestVisible
    },

    isIntroEndVisible () {
      return this.courseModuleClass.is_intro && this.isPlayerEnded && !this.courseModuleClass.is_public
        || this.courseModuleClass.is_public && this.courseModuleClass.is_intro && this.isPlayerEnded && this.isLogged
    },

    isPlaceholderGuestVisible () {
      return this.courseModuleClass.is_intro && this.isPlayerEnded && this.courseModuleClass.is_public && !this.isLogged
    }
  },

  methods: {
    ...mapActions('player', [
      'playPlayer'
    ]),

    play () {
      this.isPlayed = true
      this.playPlayer()
    }
  }
}
</script>